<template>
	<dv-border-box-12 class="applyBox">
		<div class="box">
			<div class="box_title">运用</div>
			<div class="apply_title">
				<dv-decoration-2 class='dv_dec_6' :color="['#447CA5', '#447CA5']" />
				<span>质押融资</span>
				<dv-decoration-2 class='dv_dec_6_s' :color="['#447CA5', '#447CA5']" />
			</div>
			<div class="chart">
				<div id="applychart1" :style="{ width: '100%', height: '100%' }"></div>
			</div>
			<div class="chart">
				<div id="applychart2" :style="{ width: '100%', height: '100%' }"></div>
			</div>
			<div class="applyList">
				<div class="applyItem" v-for="(item,index) in applyList" :key="index">
					<img :src="item.icon">
					<div class="applyItem_right">
						<div class="title">{{item.title}}</div>
						<div class="numbers">
							<countTo class="num" :startVal='0' :endVal='Number(item.total)' :duration='800'></countTo>
							<span>次</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</dv-border-box-12>
</template>

<script>
	export default {
		data() {
			return {
				applyList: [],
			}
		},
		mounted() {},
		methods:{
			getData(list1,list2){
				this.applyList = [
					{
						icon:require('@/assets/patent/apply-1.png'),
						title:'转让',
						total:list1.transferout,
					}, {
						icon:require('@/assets/patent/apply-2.png'),
						title:'受让',
						total:list1.transferin,
					}, {
						icon:require('@/assets/patent/apply-3.png'),
						title:'许可',
						total:list1.permitout,
					}, {
						icon:require('@/assets/patent/apply-4.png'),
						title:'被许可',
						total:list1.permitin,
					},
				]
				for(var i in list2){
					list2[i].name = list2[i].city.split('市')
				}
				this.drowChart1(list2);
				this.drowChart2(list2);
			},
			// 运用-金额亿元
			drowChart1(data) {
				let myChart = this.$echarts.init(document.getElementById('applychart1'));
				var option = {
					textStyle: {
						color: '#fff',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: 'red'
							}
						}
					},
					grid: {
						left: '0',
						right: '0',
						top: '20%',
						bottom: '0',
						containLabel: true
					},
					legend: {
						data: ["金额亿元"],
						right: 0,
						top: 0,
						textStyle: {
							color: "#fff"
						},
						itemWidth: 10,
						itemHeight: 10,
					},
					color: [{
						type: 'linear',
						x: 0,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: [{
								offset: 0,
								color: '#00C4F2'
							}, // 设置颜色渐变
							{
								offset: 1,
								color: '#0088F3'
							}
						]
					}, ],
					xAxis: [{
						type: 'category',
						data:data.map(item =>item.name[0]),
						axisTick: {
							alignWithLabel: true
						},
						axisLabel: {
							interval: 0, //数据过多时不间隔显示名称
						},
						axisLine: { //X轴坐标线隐藏
							show: false,
						},
					}, ],
					yAxis: [{
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel : {   //Y轴隐藏过后产生留白
							formatter: function(){
								return "";
							}
						}
					}],
					series: [{
						name: '金额亿元',
						type: 'bar',
						itemStyle: '',
						barWidth: '55%', //柱子粗细
						label: { //显示数值
							show: true,
							position: 'outside',
							color: '#fff'
						},
						data:data.map(item =>item.ppledgemon),
					}]
				};
				myChart.setOption(option);				
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
			// 运用-项目数（专利数）
			drowChart2(data) {
				let myChart = this.$echarts.init(document.getElementById('applychart2'));
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: 'red'
							}
						}
					},
					textStyle: {
						color: '#fff',
					},
					grid: {
						left: '0',
						right: '0',
						top: '20%',
						bottom: '0',
						containLabel: true
					},
					legend: {
						icon: 'diamond',
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 24, // 设置间距
						right: '0',
						data: ['项目数', '专利数'],
						textStyle: {
							color: '#fff',
						},
					},
					xAxis: [{
						type: 'category',
						data:data.map(item =>item.name[0]),
						axisTick: {
							alignWithLabel: true
						},
						axisLabel: {
							interval: 0, //数据过多时不间隔显示名称
						},
						axisLine: { //X轴坐标线隐藏
							show: false,
						},
					}],
					yAxis: [{
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel : {   //Y轴隐藏过后产生留白
							formatter: function(){
								return "";
							}
						}
					}],
					series: [
						{
							name: '项目数',
							type: 'bar',
							barWidth: '30%',
							barGap: '10%',
							label: { //显示数值
								show: true,
								position: 'outside',
								color: '#fff'
							},
							color: [{
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0,
										color: '#3557DF'
									}, // 设置颜色渐变
									{
										offset: 1,
										color: '#1D6BD0'
									}
								]
							}, ],
							data:data.map(item =>item.ppledgepro),
						},
						{
							name: '专利数',
							type: 'bar',
							barWidth: '30%',
							barGap: '10%',
							label: { //显示数值
								show: true,
								position: 'outside',
								color: '#fff'
							},
							color: [{
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0,
										color: '#06EB94'
									}, // 设置颜色渐变
									{
										offset: 1,
										color: '#4F8CD9'
									}
								]
							}, ],
							data:data.map(item =>item.ppledgenum),
						}
					],
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
		}
	}
</script>

<style>
</style>
